import request_ from "@/api/index_";

let requestFormAjax = request_.requestFormAjax
let requestAjax = request_.requestAjax

export const loginByDing = params => {
    return requestFormAjax({
        url: '/blade-auth/oauth/token',
        method: 'post',
        params,
        ourl: ''
    })
}